import React from 'react'
import Button from '../../../components/button/button'

const Label = ({title, content, button, onButtonClick, cta}) => {
  return (
    <div className='label-16 flex flex-col gap-2 w-full'>
      <div className='text-grey-70 flex w-full justify-between'>{title}      
        {button && <Button type='tertiary-text-underlined'
          onClick={onButtonClick}>{button}</Button>}
      </div>
      <div className='text-black'>{content}</div>
      {cta}
    </div>
  )
}

export default Label